import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import { useMount } from 'react-use'
import { AccordionBodyProps } from '@organisms/Accordion'
import Tabs, { TabsItem } from '@organisms/Tabs'
import { useGetRiskMapQuery } from '@services/riskMaps'
import OnboardingCodes from '@enums/OnboardingCodes'
import Onboarding from '@templates/Onboarding'
import ProtectionMeans from '@pages/RiskMaps/RiskMap/Body/ProtectionMeans'
import Dangers from '@pages/RiskMaps/RiskMap/Body/Dangers'
import ActionLog from '@pages/RiskMaps/RiskMap/Body/ActionLog'
import VersionsHistory from '@pages/RiskMaps/RiskMap/Body/VersionsHistory'
import { getOnboardingSteps, ONBOARDING_TITLE } from './onboarding'

type Props = {
  id: number
  index: number
} & AccordionBodyProps

const Body: FC<Props> = ({ onChangeSize, toggleLoading, id, index }) => {
  const { data } = useGetRiskMapQuery(id)

  const [active, setActive] = useState(0)

  useMount(() => {
    toggleLoading(true)
  })

  useEffect(() => {
    if (data) {
      toggleLoading(false)
      onChangeSize()
    }
  }, [data?.id])

  if (!data) return null

  const tabs: TabsItem[] = [
    {
      title: 'Опасности и риски',
      id: `dangers-tab-${index}`,
      children: (
        <Dangers
          onChangeSize={onChangeSize}
          riskMap={data}
          index={index}
          noActions
        />
      ),
    },
    {
      title: 'СИЗ',
      id: `protectionMeans-tab-${index}`,
      children: (
        <ProtectionMeans
          onChangeSize={onChangeSize}
          riskMap={data}
          index={index}
          noActions
        />
      ),
    },
    {
      title: 'Лог действий',
      id: `action-log-tab-${index}`,
      children: (
        <ActionLog
          onChangeSize={onChangeSize}
          riskMap={data}
          index={index}
          noAuthorLink
        />
      ),
    },
    {
      title: 'История версий',
      id: `versions-history-tab-${index}`,
      children: (
        <VersionsHistory
          onChangeSize={onChangeSize}
          riskMap={data}
          index={index}
          noAuthorLink
        />
      ),
    },
  ]

  return (
    <div>
      <Onboarding
        firstStepTitle={ONBOARDING_TITLE}
        steps={getOnboardingSteps(index, setActive)}
        code={OnboardingCodes.risk_map_open_card}
        withScroll
      />
      <Tabs
        items={tabs}
        active={active}
        setActive={setActive}
        onTabChange={onChangeSize}
        tabSize="small"
        withoutMaxItems
      />
    </div>
  )
}

export default Body
